module.exports = __webpack_public_path__ + "static/media/banner-dektop-artik-placeholder.732192d5.png";